import React from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import Spinner from "../../common/Spinner/Spinner";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import { Button } from "../../common/Button/Button";
import { toast } from "react-toastify";

export default function UserProfileSearchAndViewContainer(props) 
{
    const history = useHistory();
    let res={
        "fields": {
        "user_profile": [
          "EmailAddress",
          "FirstName",
          "LastName",
          "CountryCode",
          "MobileNumber",
          "Gender",
          "Age",
          "DateOfBirth",
          "Address1",
          "Address2",
          "Country",
          "State",
          "City",
          "Pincode",
          "EntryPoint",
          "EntrySource"
        ],
        "business_profile": [
          "BusinessName",
          "BusinessSector",
          "BusinessStartedYear",
          "BusinessType",
          "PANNumber",
          "Address1",
          "Address2",
          "Country",
          "State",
          "Region",
          "City",
          "Pincode",
          "FormTitle",
          "NoOfEmployees",
          "EntryDate",
          "BusinessAge",
          "AnnualTurnOver",
          "TypeOfOrganization",
          "EntryId",
          "EntrySource",
          "DNDExpiryDate",
          "ConsentFlag",
          "ChildLaboursEmployed",
          "RegisteredUnderMaharashtraStateLabourAndWelfareFundAct",
          "ProvidentFundRegulations",
          "BusinessDescription",
          "GratuityPaid",
          "TDSDeductionsDone",
          "PTECAndPTRCAvailable",
          "FollowMinimumWagesAct",
          "HasTAN",
          "BusinessProfitableinLastFY",
          "PreviousLoansPaidRegularly",
          "CanRaiseMarginMoney",
          "FiledITRForLastFY",
          "YearsInOperation",
          "RegularisedLoanRepayment",
          "CurrentAccount",
          "CanProvideGurantors",
          "CoreSkillsAvailable",
          "CanProvideCollateral",
          "BusinessVerificationDocumentsAvailability",
          "OrganizationOther",
          "IndustryExpertsSupport",
          "BusinessDocumentsAvailability",
          "RaiseMarginMoney",
          "LoanAmount",
          "BankStatement",
          "IsEligible",
          "NEFT_RTGS_UPI_NACH",
          "FinancialInstitution",
          "Coborrower",
          "DateOfAgreement",
          "BusinessCapital",
          "CapitalContributionPartner1",
          "CapitalContributionPartner2",
          "CapitalContributionPartner3",
          "CapitalContributionPartner4",
          "CapitalContributionPartner5",
          "CapitalContributionPartner6",
          "ProfitSharingRatioPartner1",
          "ProfitSharingRatioPartner2",
          "ProfitSharingRatioPartner3",
          "ProfitSharingRatioPartner4",
          "ProfitSharingRatioPartner5",
          "ProfitSharingRatioPartner6",
          "BusinessActivity",
          "RegularisedLoanEMIPayments",
          "ITRFilingDone",
          "RawMaterialInsurance",
          "ProcessesStandardization",
          "AssetsInsurance",
          "AdequateRawMaterialStock",
          "LegalCompliancesDone",
          "HaveRepeatCustomers",
          "RegularisedInterestsPayments",
          "EquipmentMaintainedRegularly",
          "EquipmentFullCapacityUtilization"
        ]
      }}

    const[activePage,setActivePage]=useState("");  
    const [isLoading, setIsLoading] = useState(false);
    const [UserProfileFieldList, setUserProfileFieldList] = useState([]);
    const [selectedUserProfileFieldList, setSelectedUserProfileFieldList] = useState([]);
    const [BusinessProfileFieldList, setBusinessProfileFieldList] = useState([]);
    const [selectedBusinessProfileFieldList, setSelectedBusinessProfileFieldList] = useState([]);

    useEffect(() => {
        if (!getUser()) 
        {
			history.push("/login");
		}
        else
        {
            const user = getUser();
            const hasSearchUserProfileReportRole = user.role.includes(11);
		    if (hasSearchUserProfileReportRole)
            {
                setActivePage("ViewProfile");
                api.getProfileSearchFields().then(({ data }) => 
                {
                    if(data)
                    {
                        const UserProfilefieldNames = data.fields.user_profile.map((idx) => {
                            return {
                                label: idx,
                                id: idx,
                                value: idx,
                            };
                        });
        
                        const BusinessProfilefieldNames = data.fields.business_profile.map((idx) => {
                            return {
                                label: idx,
                                id: idx,
                                value: idx,
                            };
                        });

                        /*let temp =[{label: "All", value: "*"}];
                        let tempSR = UserProfilefieldNames.map((e) => 
                        {
                            if (!temp.includes(e)) 
                            {
                                temp = temp.concat(e);
                            }
                            return e;
                        });*/
            
                    setUserProfileFieldList(UserProfilefieldNames);
                    setBusinessProfileFieldList(BusinessProfilefieldNames);
                    //setSelectedUserProfileFieldList(temp);
                    }
                });
            }
            else
            {
                setActivePage("No_Access");
            } 
        }
	},[]);

    const toggleAllForUserProfile = () => 
	{
		let temp =[];
		
		if (selectedUserProfileFieldList.length != UserProfileFieldList.length && selectedUserProfileFieldList.length!=(UserProfileFieldList.length+1)) 
		{
			if(selectedUserProfileFieldList.includes({label: "All", value: "*"}))
			{
				temp = selectedUserProfileFieldList;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = UserProfileFieldList.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedUserProfileFieldList(temp);
			setUserProfileFieldList(tempSR);
		} 
		else
		{
			setSelectedUserProfileFieldList([]);
		}
	};

	const toggleSelectionForUserProfile = (e) => {
		setSelectedUserProfileFieldList(e);
	};

    const toggleAllForBusinessProfile = () => 
	{
		let temp =[];
		
		if (selectedBusinessProfileFieldList.length != BusinessProfileFieldList.length && selectedBusinessProfileFieldList.length!=(BusinessProfileFieldList.length+1)) 
		{
			if(selectedBusinessProfileFieldList.includes({label: "All", value: "*"}))
			{
				temp = selectedBusinessProfileFieldList;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = BusinessProfileFieldList.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedBusinessProfileFieldList(temp);
			setBusinessProfileFieldList(tempSR);
		} 
		else
		{
			setSelectedBusinessProfileFieldList([]);
		}
	};

	const toggleSelectionForBusinessProfile = (e) => {
		setSelectedBusinessProfileFieldList(e);
	};

    const handleSearchClick = async () => {
        let filterParameters = {};
        let userProfile = [];
        selectedUserProfileFieldList.map((e) => {
            if(e.value!="*")
            {
                userProfile.push(e.value);
            }
        });
        const userProfileList=userProfile;

        let businessProfile = [];
        selectedBusinessProfileFieldList.map((e) => {
            if(e.value!="*")
            {
                businessProfile.push(e.value);
            }
        });
        const businessProfileList=businessProfile;

        if (userProfileList.length) 
        {
            filterParameters.user_profile_keys=userProfileList;
        }

        if (businessProfileList.length) 
        {
            filterParameters.business_profile_keys=businessProfileList;
        }

        if(userProfileList.length>0||businessProfileList.length>0)
        {
            setIsLoading(true);
            try {
                api.getUserProfileSearchReport(filterParameters)
                    .then(({ data }) => {
                        toast(data["message"], {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        window.open(data["generated_file"], "_self");
                        setIsLoading(false);
                    })
                    .catch((error) => {
                        setIsLoading(false);
                        toast(error["response"]["data"]["message"], {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    });
            } catch (error) {
                setIsLoading(false);
                toast("Server error.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }
        else
        {
            toast("Please select fields first.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
        }
	};

    return(
        <>        
        {
            activePage==="ViewProfile"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                   
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-12">
                            <div className="user-profile-search"> 
                                <MultiSelectAll
                                    toggleAll={toggleAllForUserProfile}
                                    toggleSelection={toggleSelectionForUserProfile}
                                    checkboxItemsList={UserProfileFieldList}
                                    selectedOptions={selectedUserProfileFieldList}
                                    placeholderButtonLabel={"Selected User Profile Fields"}
                                />
                            </div>
                            <div className="user-profile-search"> 
                                <MultiSelectAll
                                    toggleAll={toggleAllForBusinessProfile}
                                    toggleSelection={toggleSelectionForBusinessProfile}
                                    checkboxItemsList={BusinessProfileFieldList}
                                    selectedOptions={selectedBusinessProfileFieldList}
                                    placeholderButtonLabel={"Selected Business Profile Fields"}
                                />
                            </div>
                            <Button className="search-inline-button" onClick={handleSearchClick}>Search</Button>                                
                        </div>
                    </div>
                </div>
            )
            :
            activePage==="No_Access"?
            (
                <div className={`row row-container`}>
                        <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                        <label>
                            <b>You are not allowed to access this page, Please contact admin for more details.</b>
                        </label>         
                    </div>
                </div>
            )
            :
            (
                ""
            )}
        </>
    );
}